@import 'tailwindcss';

@theme {
	--color-primary: #1e40af;
	--color-primary-foreground: #ffffff;
	--color-secondary: #f1f5f9;
	--color-secondary-foreground: #0f172a;
	--color-destructive: #dc2626;
	--color-destructive-foreground: #ffffff;
	--color-muted: #f1f5f9;
	--color-muted-foreground: #64748b;
	--color-accent: #f1f5f9;
	--color-accent-foreground: #0f172a;
	--color-border: #e2e8f0;
	--color-input: #e2e8f0;
	--color-ring: #1e40af;
	--color-background: #ffffff;
	--color-foreground: #0f172a;
	--color-card: #ffffff;
	--color-card-foreground: #0f172a;
	--color-success: #15803d;
	--color-success-foreground: #ffffff;
	--color-warning: #ea580c;
	--color-warning-foreground: #ffffff;
	--radius-sm: 0.25rem;
	--radius-md: 0.375rem;
	--radius-lg: 0.5rem;
}

body {
	font-family:
		'Inter',
		system-ui,
		-apple-system,
		BlinkMacSystemFont,
		'Segoe UI',
		Roboto,
		sans-serif;
	margin: 0;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	background-color: var(--color-background);
	color: var(--color-foreground);
	/* Prevent iOS rubber-band bounce — app-like feel */
	overflow: hidden;
	position: fixed;
	width: 100%;
	height: 100%;
}

/* Preserve comfortable spacing both with and without a device cutout. */
.safe-top {
	padding-top: max(0.75rem, env(safe-area-inset-top, 0px));
}
.safe-bottom {
	padding-bottom: max(0.5rem, env(safe-area-inset-bottom, 0px));
}
.safe-x {
	padding-left: max(1rem, env(safe-area-inset-left, 0px));
	padding-right: max(1rem, env(safe-area-inset-right, 0px));
}

:where(button, a, input, select, textarea, summary, [tabindex]):focus-visible {
	outline: 3px solid var(--color-ring);
	outline-offset: 3px;
}

/* Toast animations */
@keyframes toast-slide-down {
	from { opacity: 0; transform: translateY(-100%) scale(0.95); }
	to   { opacity: 1; transform: translateY(0) scale(1); }
}
@keyframes toast-fade-out {
	from { opacity: 1; transform: translateY(0) scale(1); }
	to   { opacity: 0; transform: translateY(-20%) scale(0.95); }
}
@keyframes toast-progress {
	from { width: 100%; }
	to   { width: 0%; }
}
.toast-enter {
	animation: toast-slide-down 0.35s cubic-bezier(0.21, 1.02, 0.73, 1) forwards;
}
.toast-exit {
	animation: toast-fade-out 0.25s ease-in forwards;
}

/* Overlay slide-up animation */
@keyframes overlay-slide-up {
	from { transform: translateY(100%); }
	to   { transform: translateY(0); }
}
.overlay-enter {
	animation: overlay-slide-up 0.25s cubic-bezier(0.21, 1.02, 0.73, 1) forwards;
}

@media (prefers-reduced-motion: reduce) {
	*,
	*::before,
	*::after {
		animation-duration: 0.01ms !important;
		animation-iteration-count: 1 !important;
		transition-duration: 0.01ms !important;
		scroll-behavior: auto !important;
	}
}
